import React from 'react'
import { Chip } from '@mui/material'
import { CheckCircle as CheckCircleIcon, Cancel as CancelIcon } from '@mui/icons-material'

export const EnrollmentChip = ({ enrolled, size = 'small', variant = 'outlined' }) => {
    return (
        <Chip
            icon={enrolled ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
            label={enrolled ? 'Enrolled' : 'Not Enrolled'}
            color={enrolled ? 'success' : 'error'}
            size={size}
            variant={variant}
        />
    )
}
